import * as Raven from 'raven-js';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AlertModule } from 'ngx-bootstrap/alert';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';

//External BPA components
// import { FilterPipe } from '../bpa_client_src/app/pipes/filter.pipe';
// import { WrapperComponent } from '../bpa_client_src/app/components/wrapper/wrapper.component';
// import { BreadcrumbsComponent } from '../bpa_client_src/app/components/breadcrumbs/breadcrumbs.component';

import { AppComponent } from './app.component';

import { DashboardPage } from './components/pages/dashboard/dashboard.component';
import { UsersPage } from './components/pages/user/user-list/user-list.component';

import { AuthRESTService } from './components/services/rest/auth-rest.service';

import { CasBackendRESTService } from './components/services/rest/cas-backend-rest.service';

import { UserPage } from './components/pages/user/user-edit/user-edit.component';
import { LoginPage } from './components/pages/login/login.component';
import { RegisterPage } from './components/pages/register/register.component';
import { UserCreatePage } from './components/pages/user/user-create/user-create.component';
import { ElasticRESTService } from './components/services/rest/elastic-rest.service';
import { AuthControllerService } from './services/auth-controller/auth-controller.service';
import { AuthGuard } from './guards/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from './components/services/cookie.service';
import { AppWidgetModule } from './components/widgets/widget.module';
// import { PageLayoutModule } from './components/widgets/page-layout/page-layout.module.backup';

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Raven.captureException(err.originalError || err);
    throw err;
  }
}

let providers: any[] = [
  AuthControllerService,
  AuthRESTService,
  CasBackendRESTService,
  CookieService,
  AuthGuard,
  ElasticRESTService,
  BsModalService
];

const isLocalhost =
  location.hostname === 'localhost' ||
  location.hostname === '127.0.0.1' ||
  location.hostname === '';
if (!isLocalhost) {
  Raven.config(
    'https://2c7ee078962d43a1a10ad9158fc1b86f@sentry.io/218403'
  ).install();

  (<any>window).onunhandledrejection = function (evt) {
    Raven.captureException(evt);
  };

  (<any>window).onerror = function (evt) {
    Raven.captureException(evt);
  };

  providers.push({ provide: ErrorHandler, useClass: RavenErrorHandler });
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AppWidgetModule,
    RouterModule.forRoot([
      {
        path: '',
        component: DashboardPage,
        canActivate: [AuthGuard],
      },
      {
        path: 'login',
        component: LoginPage,
      },
      {
        path: 'register',
        component: RegisterPage,
      },
      {
        path: 'dashboard',
        component: DashboardPage,
        canActivate: [AuthGuard],
      },
      {
        path: 'users',
        component: UsersPage,
        canActivate: [AuthGuard],
        data: {
          expectedRoles: ['sysadmin'],
        },
      },
      {
        path: 'user/:id/edit',
        component: UserPage,
        canActivate: [AuthGuard],
        data: {
          expectedRoles: ['sysadmin'],
        },
      },
      {
        path: 'user/create',
        component: UserCreatePage,
        canActivate: [AuthGuard],
        data: {
          expectedRoles: ['sysadmin'],
        },
      },
    ]),
    // PageLayoutModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpFactory,
        deps: [HttpClient],
      },
    }),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    AlertModule.forRoot(),
    ToastrModule.forRoot()
  ],
  providers,
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpFactory(http: HttpClient) {
  // return new TranslateStaticLoader(http, '/assets/i18n', '.json');
  return new TranslateHttpLoader(
    http,
    '/assets/i18n/',
    '.json'
  );
}
